import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { map, Observable } from 'rxjs';

export const defaultPageResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot): Observable<string> => {
  const authService = inject(AuthService);
  const authRouteService = inject(AuthRouteService);

  const authRoute = authService.isAuthenticated() ? AuthRoute.Home : AuthRoute.Login;

  // maintain return url
  const returnUrl = route.queryParams?.returnUrl;
  const navigationExtras = {
    replaceUrl: true,
    ...(returnUrl && { queryParams: { returnUrl } })
  };

  return authRouteService.navigateToAuthRoute$(authRoute, navigationExtras).pipe(
    map(() => authRoute)
  );
};
